import { getEnglishModule } from '@uhg-psx/mapping-files-translation-transperfect';
import find from 'lodash/find';

import { ReverseCoverageTypesCodes } from '../common/Constants';
import { ConstantsLagoon } from '../common/ConstantsLagoon';
import { getFeatureFlag } from '../common/Utils';
import { ProviderType } from '../models/ProviderDetails';

export enum UserDDPCode {
  L = 'L',
  R = 'R',
  A = 'A',
  LR = 'LR',
  N = 'N',
}

const virtualCareEnglishTranslations = getEnglishModule(
  'virtualCareTranslations'
);

export const showVirtualIndicatorForCards = (
  providerType: ProviderType,
  location: { virtualCareOffered: string[] },
  featureFlags: { key: string; active: boolean }[]
): boolean => {
  const virtualCareIndicatorEnabled: boolean = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.VIRTUAL_CARE_INDICATOR_ENABLED
  );

  if (
    !virtualCareIndicatorEnabled ||
    providerType !== ProviderType.PRACTITIONER
  ) {
    return false;
  }

  return isVirtualCareAvailableInLocation(location);
};

export const isVirtualCareAvailableInLocation = (location: {
  virtualCareOffered: string[];
}) => {
  // If virtual care property does not exist at location level.
  const virtualCareOffered = location?.virtualCareOffered || [];

  if (
    virtualCareOffered.length == 0 ||
    virtualCareOffered[0] === 'N' ||
    virtualCareOffered[0] === virtualCareEnglishTranslations['N']
  ) {
    return false;
  }

  return true;
};

export const isVirtualCareIconFeatureEnabledOnDetailsHeader = (
  featureFlags: { key: string; active: boolean }[],
  coverageType: string | undefined
) => {
  const virtualCareIndicatorEnabled: boolean = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.VIRTUAL_CARE_INDICATOR_ENABLED
  );

  return (
    virtualCareIndicatorEnabled &&
    (coverageType === ReverseCoverageTypesCodes['BEHAVIORAL HEALTH'] ||
      coverageType === ReverseCoverageTypesCodes['BEHAVIORAL CARVE-OUT'] ||
      coverageType === ReverseCoverageTypesCodes.MEDICAL)
  );
};

export function shouldSuppressVirtualOnlyLocationIndicator(
  policyNumber: string,
  hasRelevantCoverage: boolean,
  suppressionFlagKey: string,
  featureSuppressionData: any[]
): boolean | undefined {
  const suppressedPolicyIds = find(featureSuppressionData, {
    DNT_feature: suppressionFlagKey,
    active: true,
  })?.policyIds;
  const isSuppressed = suppressedPolicyIds?.includes(policyNumber);
  return hasRelevantCoverage && isSuppressed ? false : undefined;
}
